export default __webpack_public_path__ + "static/s.laramee-2b8897d3f47ea6d7c028cc60bf2f85ad.png";